function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3A5C",
  d: "M5.2.148a.834.834 0 00-1.133 1.119A6.8 6.8 0 014.092 7.4a.166.166 0 01-.291-.003 3.723 3.723 0 01-.374-1.046.503.503 0 00-.802-.291 5.769 5.769 0 00-1.854 6.4 5.205 5.205 0 005.166 3.49c2.819 0 4.79-1.43 5.41-3.922.92-3.678-1.336-9.33-6.147-11.88zm3.158 11.919a2.21 2.21 0 01-2.339 1.886 2.27 2.27 0 01-2.236-1.874.333.333 0 01.404-.384 2.004 2.004 0 001.667-.94 1.534 1.534 0 00.302-1.64.333.333 0 01.407-.475 3.15 3.15 0 011.795 3.427z"
});

function SvgFlame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16
  }, props), _ref);
}

export default SvgFlame;